export default {
    lastPosition: 0,
    handleScroll() {
        const target = document.getElementsByTagName('html')[0].classList;

        if (window.scrollY < 5 || window.scrollY >= this.lastPosition) {
            target.remove('hdr-scrolled');
        } else {
            target.add('hdr-scrolled');
        }

        this.lastPosition = window.scrollY;

        // assuming average 1rem = 16px
        if (window.scrollY > 128) { // 8rem --> hdr + announcement area at the top
            // solves the positioning of the hdr
            // we don't want the -4rem to apply when the header area is still visible
            document.documentElement.dataset.scrolledPastHdr = 'true';
        } else {
            // remove the dataset
            delete document.documentElement.dataset.scrolledPastHdr;
        }
    },
    init() {
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll();

        const target = document.querySelectorAll('.js-nav-toggle');
        target.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                document.getElementsByTagName('html')[0].classList.toggle('hdr-active');
            });
        });

        const navCloseTarget = document.querySelectorAll('.hdr .hdr__billboard-background');
        navCloseTarget.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelector('.hdr .hdr__li.active').classList.remove('active');
            });
        });
    },
};
